import {Component, OnInit, Renderer2} from '@angular/core';
import {CustomizerService} from './services/customizer.service';
import {ClarityConfigService} from './services/clarity-config.service';
import {CurrencyService} from './services/currency.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent implements OnInit {
  title = 'Arcon';

  constructor(public customizer: CustomizerService,
    private clarityConfigService: ClarityConfigService,
    private renderer: Renderer2,
    private currencyService: CurrencyService) {

  }

  ngOnInit(): void {
    const clarityTrackingId = this.clarityConfigService.getTrackingId();

    // Dynamically load Clarity script with the tracking ID
    const clarityScript = this.renderer.createElement('script');
    clarityScript.type = 'text/javascript';
    clarityScript.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${clarityTrackingId}");
    `;

    // console.log(window.location);
      // if (window.location.hostname.includes('portaluat.arconcontainer.com') || window.location.hostname.includes('portal.arconcontainer.com'))
      //   this.renderer.appendChild(document.head, clarityScript);

    this.currencyService.getAllCurrencies();
  }
}
